import React from 'react'
import { PageBody } from './style'
import CustomAlert from '../../CustomAlert'
import useAlertStore from '../../../hooks/useAlert'

const Component = props => {
  const { alert, hideAlert } = useAlertStore();

  return (
    <PageBody>
      {props.header}
      <div style={{ width: '100%', maxWidth: '1700px', margin: '0 auto', padding: '0 20px' }}>
        {props.children}
      </div>
      {props.footer}
      {alert && (
        <CustomAlert
          message={alert.message}
          title={alert.title}
          type={alert.type}
          onClose={hideAlert}
        />
      )}
    </PageBody>
  );
};

export default Component;